import React, { useState, useEffect } from 'react'
import Header from '../../components/Header'
import Footer from '../../components/Footer'
import usePageSEO from '../../hooks/usePageSEO'
import axios from "axios";
import Loader from '../../components/Loader'

const Reach = () => {
  const [loading, setLoading] = useState(true);
  const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
  const siteUrl = process.env.REACT_APP_BACKEND_URL;
  const [ourReachWidget, setOurRechWidget] = useState()
  const [metaTitle, setMetaTitle] = useState('')
  const [metaDescription, setMetaDescription] = useState('')

  const apiUrl = apiBaseUrl+`aboutpage`;



  const fetchPagedata = async() => {
    try{
    return await axios.get(apiUrl).then((res) => {
      setMetaTitle(res.data.page.meta_title);
      setMetaDescription(res.data.page.meta_description);
      setOurRechWidget(res.data.ourreachwidget)
    });
    }catch(err){
      console.log(err);
    }
  };  

  useEffect(() => {
    setTimeout(() => {
      fetchPagedata()
        setLoading(false);
    }, 2000);
  }, []);

  usePageSEO({
    title: `${metaTitle}`,
    description: `${metaDescription}`
  })  


  return (
    <>
    <Header/>

    { loading && (<Loader />)}
    
    <div id="reach" className="container vertical-gap"><hr /></div>
  
    <section className="section-content-block ">
      <div className="container">
          <div className="row">
              <div className="col-lg-6 col-md-6 col-sm-12">                       
                <div className="about-us-intro Reach">
                  <p className="blue">{ourReachWidget?.name}</p>
                  <h2 className="heading">{ourReachWidget?.heading}</h2>
                  <p>{ourReachWidget?.description}</p>
                </div>                            
              </div> 
              <div className="col-lg-6 col-md-6 col-sm-12 text-right">
                <img src={`${siteUrl}${ourReachWidget?.image}`} alt={ourReachWidget?.name} />              
              </div>
          </div>
      </div> 
    </section>

    <Footer/>
    </>
  )
}

export default Reach